// extracted by mini-css-extract-plugin
export default {"buttonWrap":"PaymentPlanTab_buttonWrap__+HKEJ","newItemText":"PaymentPlanTab_newItemText__xW2N6"};